// Saga for the Communication / Notification settings feature

import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  GET_COMMUNICATION_LIST,
  GET_COMMUNICATION_CHANNEL_LIST,
  CREATE_COMMUNICATION_CHANNEL,
  UPDATE_COMMUNICATION_CHANNEL,
  GET_COMMUNICATION_PLACEHOLDER_LIST,
  GET_NOTIFICATION_TEMPLATE_LIST,
} from "./actionType";

import {
  getCommunicationListSuccess,
  getCommunicationListFail,
  getCommunicationChannelListSuccess,
  getCommunicationChannelListFail,
  createCommunicationChannelSuccess,
  createCommunicationChannelFail,
  updateCommunicationChannelSuccess,
  updateCommunicationChannelFail,
  getCommunicationPlaceholderListSuccess,
  getCommunicationPlaceholderListFail,
  getNotificationTemplateListSuccess,
  getNotificationTemplateListFail,
} from "./action";

import {
  getCommunicationListApiCall,
  getCommunicationChannelListApiCall,
  createCommunicationChannelApiCall,
  updateCommunicationChannelApiCall,
  getCommunicationPlaceholderListApiCall,
  getNotificationTemplateListApiCall,
} from "../../helpers/fakebackend_helper";

// Communication list
function* onGetCommunicationList() {
  try {
    const response = yield call(getCommunicationListApiCall);
    yield put(getCommunicationListSuccess(response));
  } catch (error) {
    yield put(getCommunicationListFail(error));
  }
}
export function* watchGetCommunicationList() {
  yield takeEvery(GET_COMMUNICATION_LIST, onGetCommunicationList);
}

// Communication channel list
function* onGetCommunicationChannelList() {
  try {
    const response = yield call(getCommunicationChannelListApiCall);
    yield put(getCommunicationChannelListSuccess(response));
  } catch (error) {
    yield put(getCommunicationChannelListFail(error));
  }
}
export function* watchGetCommunicationChannelList() {
  yield takeEvery(
    GET_COMMUNICATION_CHANNEL_LIST,
    onGetCommunicationChannelList
  );
}

// Create communication channel
function* onCreateCommunicationChannel({ payload }) {
  try {
    const response = yield call(createCommunicationChannelApiCall, payload);
    yield put(createCommunicationChannelSuccess(response));
  } catch (error) {
    yield put(createCommunicationChannelFail(error));
  }
}
export function* watchCreateCommunicationChannel() {
  yield takeEvery(CREATE_COMMUNICATION_CHANNEL, onCreateCommunicationChannel);
}

// Update communication channel
function* onUpdateCommunicationChannel({ payload }) {
  try {
    const response = yield call(updateCommunicationChannelApiCall, payload);
    yield put(updateCommunicationChannelSuccess(response));
  } catch (error) {
    yield put(updateCommunicationChannelFail(error));
  }
}
export function* watchUpdateCommunicationChannel() {
  yield takeEvery(UPDATE_COMMUNICATION_CHANNEL, onUpdateCommunicationChannel);
}

// Communication placeholder list
function* onGetCommunicationPlaceholderList() {
  try {
    const response = yield call(getCommunicationPlaceholderListApiCall);
    yield put(getCommunicationPlaceholderListSuccess(response));
  } catch (error) {
    yield put(getCommunicationPlaceholderListFail(error));
  }
}
export function* watchGetCommunicationPlaceholderList() {
  yield takeEvery(
    GET_COMMUNICATION_PLACEHOLDER_LIST,
    onGetCommunicationPlaceholderList
  );
}

// Notification template list
function* onGetNotificationTemplateList() {
  try {
    const response = yield call(getNotificationTemplateListApiCall);
    yield put(getNotificationTemplateListSuccess(response));
  } catch (error) {
    yield put(getNotificationTemplateListFail(error));
  }
}
export function* watchGetNotificationTemplateList() {
  yield takeEvery(
    GET_NOTIFICATION_TEMPLATE_LIST,
    onGetNotificationTemplateList
  );
}

function* communicationSaga() {
  yield all([
    fork(watchGetCommunicationList),
    fork(watchGetCommunicationChannelList),
    fork(watchCreateCommunicationChannel),
    fork(watchUpdateCommunicationChannel),
    fork(watchGetCommunicationPlaceholderList),
    fork(watchGetNotificationTemplateList),
  ]);
}

export default communicationSaga;
